import React from "react";
import { ProGallery } from "pro-gallery";
import "pro-gallery/dist/statics/main.css";

export default function Gallery() {
  // Add your images here...
  const items = [
    {
      // Image item:
      itemId: "imgPavsic",
      mediaUrl:
        "https://www.fvv.um.si/wp-content/uploads/2022/06/DSC_0022-scaled-e1654761507945-768x1152.jpg",
      metaData: {
        type: "image",
        height: 1152,
        width: 768,
        title: "Tinkara Pavšič Mrevlje",
        description: "sample-description",
        focalPoint: [0, 0],
        // link: {
        //   url: "http://example.com",
        //   target: "_blank",
        // },
      },
    },
    {
      // Another Image item:
      itemId: "differentItem",
      mediaUrl:
        "https://www.fvv.um.si/wp-content/uploads/2022/06/DSC_0034-1160x773.jpg",
      metaData: {
        type: "image",
        height: 773,
        width: 1160,
        title: "sample-title",
        description: "sample-description",
        focalPoint: [0, 0],
        // link: {
        //   url: "http://example.com",
        //   target: "_blank",
        // },
      },
    },
    {
      // Another Image item:
      itemId: "differentItem1",
      mediaUrl:
        "https://www.fvv.um.si/wp-content/uploads/2022/06/DSC_0043-scaled-e1654761489596-768x1152.jpg",
      metaData: {
        type: "image",
        height: 1152,
        width: 768,
        title: "sample-title",
        description: "sample-description",
        focalPoint: [0, 0],
        // link: {
        //   url: "http://example.com",
        //   target: "_blank",
        // },
      },
    },
    {
      // Another Image item:
      itemId: "differentItem2",
      mediaUrl:
        "https://www.fvv.um.si/wp-content/uploads/2022/06/DSC_0050-scaled-e1654761472493-768x1152.jpg",
      metaData: {
        type: "image",
        height: 1152,
        width: 768,
        title: "sample-title",
        description: "sample-description",
        focalPoint: [0, 0],
        // link: {
        //   url: "http://example.com",
        //   target: "_blank",
        // },
      },
    },
    {
      // Another Image item:
      itemId: "differentItem3",
      mediaUrl:
        "https://www.fvv.um.si/wp-content/uploads/2022/06/DSC_0052-scaled-e1654761459807-768x1152.jpg",
      metaData: {
        type: "image",
        height: 1152,
        width: 768,
        title: "sample-title",
        description: "sample-description",
        focalPoint: [0, 0],
        // link: {
        //   url: "http://example.com",
        //   target: "_blank",
        // },
      },
    },
    {
      // Another Image item:
      itemId: "differentItem3a",
      mediaUrl:
        "https://www.fvv.um.si/wp-content/uploads/2022/06/DSC_0067-1160x773.jpg",
      metaData: {
        type: "image",
        height: 773,
        width: 1160,
        title: "sample-title",
        description: "sample-description",
        focalPoint: [0, 0],
        // link: {
        //   url: "http://example.com",
        //   target: "_blank",
        // },
      },
    },
    {
      // Another Image item:
      itemId: "differentItem4",
      mediaUrl:
        "https://www.fvv.um.si/wp-content/uploads/2022/06/DSC_0200-1160x773.jpg",
      metaData: {
        type: "image",
        height: 773,
        width: 1160,
        title: "sample-title",
        description: "sample-description",
        focalPoint: [0, 0],
        // link: {
        //   url: "http://example.com",
        //   target: "_blank",
        // },
      },
    },
    {
      // Another Image item:
      itemId: "differentItem5",
      mediaUrl:
        "https://www.fvv.um.si/wp-content/uploads/2022/06/DSC_0101-1160x773.jpg",
      metaData: {
        type: "image",
        height: 773,
        width: 1160,
        title: "sample-title",
        description: "sample-description",
        focalPoint: [0, 0],
        // link: {
        //   url: "http://example.com",
        //   target: "_blank",
        // },
      },
    },
  ];

  // The options of the gallery (from the playground current state)
  const options = {
    layoutParams: {
      structure: {
        galleryLayout: 1,
        enableStreching: false,
        titlePlacement: "SHOW_BELOW",
        imageInfoType: "ATTACHED_BACKGROUND",
      },
    },
  };

  // The size of the gallery container. The images will fit themselves in it
  const container = {
    // width: window.innerWidth,
    // height: window.innerHeight,
    width: 1280,
    height: 4000,
  };

  // The eventsListener will notify you anytime something has happened in the gallery.
  const eventsListener = (eventName, eventData) =>
    console.log({ eventName, eventData });

  // The scrollingElement is usually the window, if you are scrolling inside another element, suplly it here
  //   const scrollingElement = window;
  const scrollingElement = typeof window !== "undefined" && window;

  return (
    <ProGallery
      items={items}
      options={options}
      container={container}
      eventsListener={eventsListener}
      scrollingElement={scrollingElement}
    />
  );
}

// Enjoy using your new gallery!
// For more options, visit https://github.com/wix/pro-gallery
